export default "__VITE_ASSET__xtRnLWeF__"